import React from 'react';
import useStyles from './styles';
import { StatusKeys } from './types';
import { getColorByStatus } from './utils';

type Props = {
  statusKey: StatusKeys;
};

const StatusIcon = ({ statusKey }: Props) => {
  const classes = useStyles();
  const color = getColorByStatus(statusKey);
  return (
    <span className={classes.icon} style={{ background: color }} />
  );
};

export default StatusIcon;
